import { render, staticRenderFns } from "./QiaohuPopup.vue?vue&type=template&id=215ffbae&scoped=true"
import script from "./QiaohuPopup.vue?vue&type=script&lang=js"
export * from "./QiaohuPopup.vue?vue&type=script&lang=js"
import style0 from "./QiaohuPopup.vue?vue&type=style&index=0&id=215ffbae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ffbae",
  null
  
)

export default component.exports